export default __webpack_public_path__ + "static/media/grafema_packaging-cale-do-oiro_05.0f0869a9.jpg";